import { Bagian } from './Bagian'

/**
 * Urutan langkah yang memang berurutan — di sini nomor urutnya membawa
 * informasi, bukan hiasan.
 */
const LANGKAH = [
  {
    judul: 'Install the agent',
    isi: 'Download Orisini Agent and install it on your computer. Google Chrome must already be there — the agent uses real Chrome so your session looks like ordinary use.',
  },
  {
    judul: 'Sign in once',
    isi: 'Your Orisini account credentials are exchanged for a device token and not stored. The session cookie is set on the parent domain, so one sign-in works across all products.',
  },
  {
    judul: 'Build the queue',
    isi: "From any product you're subscribed to, set the content and publish time. You can fill several weeks ahead at once.",
  },
  {
    judul: 'Let it publish',
    isi: 'While the computer is on, the agent publishes on time and reports the result back to the queue — along with the post link.',
  },
]

export function BagianCara() {
  return (
    <Bagian
      id="how-it-works"
      judul="Your computer is the one that presses publish"
      keterangan="Orisini holds the schedule; the agent on your computer does the actual posting. No platform's official API is used, and your logins never leave that machine."
    >
      <ol className="grid gap-x-8 gap-y-8 border-t border-border pt-8 sm:grid-cols-2 lg:grid-cols-4">
        {LANGKAH.map((l, i) => (
          <li key={l.judul} className="space-y-2">
            <span className="text-xs tabular-nums text-primary">{i + 1}</span>
            <h3 className="font-medium">{l.judul}</h3>
            <p className="text-sm text-muted-foreground">{l.isi}</p>
          </li>
        ))}
      </ol>

      <p className="mt-10 max-w-2xl text-sm text-muted-foreground">
        The consequence is honest: the computer has to be on when the schedule arrives, and for
        now the app only runs on Windows. That is the price of not using official APIs — and it
        is also what keeps your platform accounts in your hands.
      </p>
    </Bagian>
  )
}
